// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__ZKsmz","notes":"Notes_notes__3Mixf"};